export enum EventSponsorshipEnum {
    EventNotSponsored = "118950000",
    EventOrganisedManagedOrHostedByOrOnBehalfOfSingleIndustrySponsor = "118950001",
    EventWithMultipleIndustrySponsors = "118950002",
    EventSupportedByAnUnrestrictedEducationGrant = "118950003"
}